/** Shared route-level tab strip. Each section owns its nested-route content. */
import { NavLink } from "react-router-dom";

function tabSlug(label) {
  return label.toLowerCase().replace(/\s+/g, "-");
}

export default function SectionNav({ tabs, ariaLabel, testIdPrefix }) {
  return (
    <nav
      className="flex gap-2 mb-4 overflow-x-auto whitespace-nowrap"
      aria-label={ariaLabel}
      data-testid={`${testIdPrefix}-sub-nav`}
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          onMouseEnter={tab.onHover}
          onFocus={tab.onHover}
          className={({ isActive }) =>
            `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? "bg-[#EE2677] text-white shadow-sm"
                : "bg-white text-[#2D2D2D] border border-[#EBB3A9]/50 hover:bg-[#FFF3EE]"
            }`
          }
          data-testid={`${testIdPrefix}-tab-${tabSlug(tab.label)}`}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
